import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { IconComponent } from '@shared/components/icon/icon.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';
import { LocalStorageKey } from '@shared/constants/localStorageKey';
import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'aux-change-order-approved-dialog',
  styles: [],
  templateUrl: './change-order-approved-dialog.component.html',
})
export class ChangeOrderApprovedDialogComponent {
  ref = inject(CustomOverlayRef<unknown, { vendor_id?: string }>);

  private router = inject(Router);

  co_organization_id: string | undefined;
  expenseDetailRoute = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.EXPENSE_DETAIL}`;
  forecastMethadologyRoute = `/${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.FORECAST_METHODOLOGY}`;
  timelineRoute = `/${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.TIMELINE}`;

  constructor() {
    if (this.ref.data && this.ref.data.vendor_id) {
      this.co_organization_id = this.ref.data?.vendor_id;
    }
  }

  goExpenseDetail() {
    void this.router.navigate([this.expenseDetailRoute], {
      queryParams: { vendorId: this.co_organization_id },
    });
    this.ref.close();
  }

  goFM() {
    if (this.co_organization_id) {
      localStorage.setItem(LocalStorageKey.FORECAST_VENDOR, this.co_organization_id);
    }

    void this.router.navigateByUrl(this.forecastMethadologyRoute);
    this.ref.close();
  }

  goTimeline() {
    void this.router.navigateByUrl(this.timelineRoute);
    this.ref.close();
  }
}
